import React from "react";
import { motion } from "framer-motion";
import "./Services.css";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.65 } },
};

const services = [
  {
    title: "Printer setup",
    desc: "Drivers, Wi‑Fi pairing, USB installs, and offline printer recovery for major home and office brands.",
    href: "/printlab",
    label: "Open printer help",
  },
  {
    title: "Wi‑Fi extender help",
    desc: "Placement, pairing, firmware, and login-page issues for Netgear, TP‑Link, Linksys, and D‑Link.",
    href: "/wavelab",
    label: "Open extender help",
  },
  {
    title: "Live specialist support",
    desc: "Share your model and error — a technician guides you step by step until the device is working.",
    href: "/contact",
    label: "Contact support",
  },
  {
    title: "Brand-specific guides",
    desc: "HP, Canon, Epson, Brother, and leading router brands — tailored flows instead of generic manuals.",
    href: "/services",
    label: "See all services",
  },
];

const Services = () => (
  <section className="srv2" aria-label="Services">
    <div className="srv2__page">
      <p className="srv2__kicker">Services</p>
      <h1 className="srv2__pageTitle">What we help you set up</h1>
      <p className="srv2__pageLead">
        Printers, routers, and Wi‑Fi extenders — clear steps, brand-specific guides, and live help when stuck.
      </p>
    </div>
    <div className="srv2__grid">
      {services.map((s, i) => (
        <motion.a
          key={s.title}
          href={s.href}
          className="srv2__card"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
          transition={{ delay: i * 0.05 }}
        >
          <h3 className="srv2__h3">{s.title}</h3>
          <p className="srv2__p">{s.desc}</p>
          <span className="srv2__link">{s.label} →</span>
        </motion.a>
      ))}
    </div>
  </section>
);

export default Services;
